import { ecorEnv } from '@/../environments/environment';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class NotificationOptDialogHttpService {
    constructor(private httpClient: HttpClient) { }

    updatePaperlessOptToN(userAccountId: number, surveyInstanceId: number): Observable<any> {
        return this.updatePaperlessOpt(userAccountId, surveyInstanceId, 'N');
    }

    updatePaperlessOptToY(userAccountId: number, surveyInstanceId: number): Observable<any> {
        return this.updatePaperlessOpt(userAccountId, surveyInstanceId, 'Y');
    }

    
    


    updatePaperlessOpt(userAccountId: number, surveyInstanceId: number, paperlessFlag: string): Observable<any> {
        // Add null checks to prevent runtime errors
        if (userAccountId == null || userAccountId == undefined || surveyInstanceId == null || surveyInstanceId == undefined) {
            return throwError('Invalid userAccountId or surveyInstanceId');
        }
        
        const params = new HttpParams()
            .set('paperlessFlag', paperlessFlag)
            .set('surveyInstanceId', surveyInstanceId.toString());
        const addSurveyUrl = ecorEnv.apiEndpoint + '/secure/surveys/updatePaperlessFlag/' + userAccountId;
        return this.httpClient.post<any>(addSurveyUrl, null, { params })
            .pipe(
                catchError(this.handleError)
            );
    }

    private handleError(error: HttpErrorResponse) {
        console.error('notification-opt-dialog-http', 'error', error);
        if (typeof error.error !== 'undefined' && error.error instanceof ErrorEvent) {
            console.error('notification-opt-dialog-http', 'client side error:', error.error);
        } else {
            return throwError(error);
        }
        return throwError('Error-222222');
    }
}
